export * from './create/create.component';
export * from './list/list.component';
export * from './update/update.component';
export * from './star-rating/star-rating.component';
